const handleDateTimeToDate = (dt) => {
    if (!dt) return '';
    const i = dt.indexOf('T');
    if (i === -1) return dt;
    return dt.substring(0, i);
}

export { handleDateTimeToDate };